<template>
  <div
    class="switcher clickable"
    @click="toggleSwitch"
    :style="{
      width: '40px',
      padding: '2px',
      backgroundColor: toggle ? '#55ACEE' : '#BABABA',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: toggle ? 'flex-end' : 'flex-start',
    }"
  >
    <div
      class="switcher__circle"
      :style="{
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        backgroundColor: '#FFF',
      }"
    />
  </div>
</template>

<script setup>
import {ref} from 'vue';

const toggle = ref(true);

const toggleSwitch = () => {
  toggle.value = !toggle.value;
};
</script>
